import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const RegionBasicInfoComponent = ({ employees, transporters, zones, onInnerBasicFormChange, selectedRegions }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Region Name"
                    name="RegionName"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'RegionName'

                        )
                    }}
                    type="text"
                    value={selectedRegions?.RegionName}
                />

                <InputContainer
                    label="Contact Person"
                    name="ContactPerson"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ContactPerson'

                        )
                    }}
                    type="text"
                    value={selectedRegions?.ContactPerson}
                />
                 <InputContainer
                    label="Contact Number"
                    name="ContactNumber"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ContactNumber'

                        )
                    }}
                    type="number"
                    value={selectedRegions?.ContactNumber}
                />
                <InputContainer

                    label="Zone"
                    labelField="LogisticsZoneName"
                    list={zones}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'LogisticsZoneId'

                        );
                    }}
                    optionName='Choose LogisticsZone'
                    type="select"
                    value={selectedRegions?.LogisticsZoneId}
                    valueField="Id"
                />
                <InputContainer

                    label="Employee"
                    labelField="FirstName"
                    list={employees}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EmployeeId'

                        );
                    }}
                    optionName='Choose Employee'
                    type="select"
                    value={selectedRegions?.EmployeeId}
                    valueField="Id"
                />
                <InputContainer
                    label="Transporter"
                    labelField="Name"
                    list={transporters}
                    onValueChange={(newValue: any) => {
                        const pinCodeData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            pinCodeData,
                            'TransporterIds'
                        )
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={selectedRegions?.TransporterIds}
                />

            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default RegionBasicInfoComponent;
